export default __webpack_public_path__ + "static/strahovanie-ff3b86ed647262ccf2c8316322757f77.png";